import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from "react-router-dom";
import './index.css';
import App from './components/App/App';
import reportWebVitals from './reportWebVitals';


const router = <BrowserRouter> <App /> </BrowserRouter>;
ReactDOM.render(router, document.getElementById('root'));

reportWebVitals();
